/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 * **/
export const SET_SELECTED_INPUT_MONTHLY = 'SET_SELECTED_INPUT_MONTHLY';
export const IS_LOADING = 'IS_LOADING';
export const SET_REQUEST_SCREEN_GRID_MONTHLY =
  'SET_REQUEST_SCREEN_GRID_MONTHLY';
export const REFRESH_MONTHLY_CLAIMS_RECONCILLIATION_MONTHLY =
  'REFRESH_MONTHLY_CLAIMS_RECONCILLIATION_MONTHLY';
export const SET_RIGHT_GRID_DATA_MONTHLY = 'SET_RIGHT_GRID_DATA_MONTHLY';
export const SET_LEFT_GRID_DATA_MONTHLY = 'SET_LEFT_GRID_DATA_MONTHLY';
export const SET_SELECTED_REQUEST_MONTHLY = 'SET_SELECTED_REQUEST_MONTHLY';
export const SET_LAST_UPDATED_USERID_AND_COUNT_MONTHLY =
  'SET_LAST_UPDATED_USERID_AND_COUNT_MONTHLY';
export const SET_SCHEDULE_MESSAGE_MONTHLY = 'SET_SCHEDULE_MESSAGE_MONTHLY';
